import Equipment from '../../Components/Vimdt/Equipments/Equipment';
import useRowCount from '../../Utils/Vimdt/useRowCount';

function EquipmentsPage() {
	return <Equipment rowCount={useRowCount()} />;
}

export default EquipmentsPage;
